import React from 'react';

interface FeedbackButtonProps {
  onClick: () => void;
}

const FeedbackButton: React.FC<FeedbackButtonProps> = ({ onClick }) => (
  <button
    onClick={onClick}
    aria-label="Open feedback"
    style={{
      position: 'fixed',
      left: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      background: '#E8368A',
      color: '#fff',
      border: 'none',
      cursor: 'pointer',
      padding: '14px 10px',
      borderRadius: '0 8px 8px 0',
      writingMode: 'vertical-lr',
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: 700,
      fontSize: '0.75rem',
      letterSpacing: '0.08em',
      zIndex: 999,
      boxShadow: '2px 0 8px rgba(0,0,0,0.18)',
      transition: 'background 0.2s ease',
    }}
    onMouseEnter={e => (e.currentTarget.style.background = '#c42d77')}
    onMouseLeave={e => (e.currentTarget.style.background = '#E8368A')}
  >
    Feedback
  </button>
);

export default FeedbackButton;
